<template>
  <div
    class="btn main hollow"
    :class="{ bordered }"
    @click="$emit('click', $event)"
    @mousedown="$emit('mousedown')"
    @mouseup="$emit('mouseup')"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    bordered: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
<style scoped>
.btn.main.filled {
  color: var(--color-white);
  background-color: var(--color-main);
}
</style>
<style scoped src="./btn/shared.css"></style>
<style scoped src="./btn/shared_gt_768.css"></style>
<style scoped src="./btn/shared_gt_375.css"></style>
<style src="./btn/unscopedShared.css"></style>
<style src="./btn/unscopedShared375.css"></style>
